import { useContext, useEffect, useRef } from 'react';
import { BannerContext } from 'app/agriculture/contexts/BannerContextProvider';

export function BannerPortal() {
    const { setBannerRef } = useContext(BannerContext);
    const ref = useRef<HTMLDivElement>(null);
    useEffect(() => {
        setBannerRef(ref.current);
        return () => {
            setBannerRef(null);
        };
    }, [ref]);

    return <div ref={ref} />;
}
